/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ACL,
  ACLAuthorization,
  ACLAuthorizationRequest,
  ChangeRequest,
  ChangeRequestCreateRequest,
  ChangeRequestPatchRequest,
  ErrorResponse,
  EventCreateRequest,
  LogisticsObjectMetadata,
  PaginatedChangeRequests,
  PaginatedEvents,
  SearchServiceRequestsRequest,
  SearchServiceRequestsResponse,
  ServiceRequest,
  ServiceRequestResponse,
} from '../models/index';
import {
    ACLFromJSON,
    ACLToJSON,
    ACLAuthorizationFromJSON,
    ACLAuthorizationToJSON,
    ACLAuthorizationRequestFromJSON,
    ACLAuthorizationRequestToJSON,
    ChangeRequestFromJSON,
    ChangeRequestToJSON,
    ChangeRequestCreateRequestFromJSON,
    ChangeRequestCreateRequestToJSON,
    ChangeRequestPatchRequestFromJSON,
    ChangeRequestPatchRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventCreateRequestFromJSON,
    EventCreateRequestToJSON,
    LogisticsObjectMetadataFromJSON,
    LogisticsObjectMetadataToJSON,
    PaginatedChangeRequestsFromJSON,
    PaginatedChangeRequestsToJSON,
    PaginatedEventsFromJSON,
    PaginatedEventsToJSON,
    SearchServiceRequestsRequestFromJSON,
    SearchServiceRequestsRequestToJSON,
    SearchServiceRequestsResponseFromJSON,
    SearchServiceRequestsResponseToJSON,
    ServiceRequestFromJSON,
    ServiceRequestToJSON,
    ServiceRequestResponseFromJSON,
    ServiceRequestResponseToJSON,
} from '../models/index';

export interface CreateChangeRequestOnServiceRequestByIdRequest {
    serviceRequestId: string;
    contentType: CreateChangeRequestOnServiceRequestByIdContentTypeEnum;
    changeRequestCreateRequest: ChangeRequestCreateRequest;
    source?: boolean;
    accept?: CreateChangeRequestOnServiceRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface CreateServiceRequestRequest {
    contentType: CreateServiceRequestContentTypeEnum;
    xBOLMemberIdentifier: string;
    serviceRequest: ServiceRequest;
    id?: string;
    source?: boolean;
    accept?: CreateServiceRequestAcceptEnum;
    traceparent?: string;
    xBOLACLAuthorizations?: string;
}

export interface CreateServiceRequestEventRequest {
    serviceRequestId: string;
    contentType: CreateServiceRequestEventContentTypeEnum;
    xBOLMemberIdentifier: string;
    eventCreateRequest: EventCreateRequest;
    accept?: CreateServiceRequestEventAcceptEnum;
    traceparent?: string;
}

export interface DeleteServiceRequestACLAuthorizationByMemberIdRequest {
    serviceRequestId: string;
    memberId: string;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    traceparent?: string;
}

export interface DeleteServiceRequestByIdRequest {
    serviceRequestId: string;
    traceparent?: string;
}

export interface DeleteServiceRequestEventByIdRequest {
    serviceRequestId: string;
    eventId: string;
    xBOLMemberIdentifier: string;
    traceparent?: string;
}

export interface GetChangeRequestOnServiceRequestByIdRequest {
    serviceRequestId: string;
    changeRequestId: string;
    accept?: GetChangeRequestOnServiceRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface GetServiceRequestACLAuthorizationByMemberIdRequest {
    serviceRequestId: string;
    memberId: string;
    at?: string;
    aclRevision?: string;
    accept?: GetServiceRequestACLAuthorizationByMemberIdAcceptEnum;
    traceparent?: string;
}

export interface GetServiceRequestACLByIdRequest {
    serviceRequestId: string;
    at?: string;
    revision?: string;
    accept?: GetServiceRequestACLByIdAcceptEnum;
    traceparent?: string;
}

export interface GetServiceRequestByIdRequest {
    serviceRequestId: string;
    at?: string;
    revision?: string;
    accept?: GetServiceRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface GetServiceRequestEventsRequest {
    serviceRequestId: string;
    limit?: number;
    offset?: number;
    startAt?: Date;
    endAt?: Date;
    code?: string;
    type?: string;
    accept?: GetServiceRequestEventsAcceptEnum;
    traceparent?: string;
}

export interface GetServiceRequestMetadataByIdRequest {
    serviceRequestId: string;
    accept?: GetServiceRequestMetadataByIdAcceptEnum;
    traceparent?: string;
}

export interface ListChangeRequestsOfServiceRequestByIdRequest {
    serviceRequestId: string;
    limit?: number;
    offset?: number;
    accept?: ListChangeRequestsOfServiceRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface PatchServiceRequestByIdRequest {
    serviceRequestId: string;
    contentType: PatchServiceRequestByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    serviceRequest: ServiceRequest;
    revision?: string;
    accept?: PatchServiceRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface SearchServiceRequestGetRequest {
    id?: string;
    searchBody?: SearchServiceRequestsRequest;
    accept?: SearchServiceRequestGetAcceptEnum;
    traceparent?: string;
}

export interface SearchServiceRequestsPostRequest {
    contentType: SearchServiceRequestsPostContentTypeEnum;
    searchServiceRequestsRequest: SearchServiceRequestsRequest;
    limit?: number;
    offset?: number;
    accept?: SearchServiceRequestsPostAcceptEnum;
    traceparent?: string;
}

export interface UpdateChangeRequestOnServiceRequestByIdRequest {
    serviceRequestId: string;
    changeRequestId: string;
    contentType: UpdateChangeRequestOnServiceRequestByIdContentTypeEnum;
    changeRequestPatchRequest: ChangeRequestPatchRequest;
    accept?: UpdateChangeRequestOnServiceRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface UpdateServiceRequestByIdRequest {
    serviceRequestId: string;
    contentType: UpdateServiceRequestByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    serviceRequest: ServiceRequest;
    revision?: string;
    accept?: UpdateServiceRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface UpsertServiceRequestACLAuthorizationByIdRequest {
    serviceRequestId: string;
    contentType: UpsertServiceRequestACLAuthorizationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    accept?: UpsertServiceRequestACLAuthorizationByIdAcceptEnum;
    traceparent?: string;
    aCLAuthorizationRequest?: ACLAuthorizationRequest;
}

/**
 * 
 */
export class LogisticsObjectsServiceRequestsApi extends runtime.BaseAPI {

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific ServiceRequest resource, identified by its `ServiceRequestId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the ServiceRequest resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a ServiceRequest resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the ServiceRequest resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a ServiceRequest
     */
    async createChangeRequestOnServiceRequestByIdRaw(requestParameters: CreateChangeRequestOnServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling createChangeRequestOnServiceRequestById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createChangeRequestOnServiceRequestById().'
            );
        }

        if (requestParameters['changeRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateRequest',
                'Required parameter "changeRequestCreateRequest" was null or undefined when calling createChangeRequestOnServiceRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/change-requests`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateRequestToJSON(requestParameters['changeRequestCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific ServiceRequest resource, identified by its `ServiceRequestId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the ServiceRequest resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a ServiceRequest resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the ServiceRequest resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a ServiceRequest
     */
    async createChangeRequestOnServiceRequestById(requestParameters: CreateChangeRequestOnServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest | null | undefined > {
        const response = await this.createChangeRequestOnServiceRequestByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  This endpoint allows the creation of a new ServiceRequest.  When creating a ServiceRequest, the value of the header `X-BOL-Member-Identifier` defines the ServiceRequest\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a ServiceRequest, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the ServiceRequest and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the ServiceRequest, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the ServiceRequest.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a ServiceRequest
     */
    async createServiceRequestRaw(requestParameters: CreateServiceRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceRequestResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createServiceRequest().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createServiceRequest().'
            );
        }

        if (requestParameters['serviceRequest'] == null) {
            throw new runtime.RequiredError(
                'serviceRequest',
                'Required parameter "serviceRequest" was null or undefined when calling createServiceRequest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (requestParameters['xBOLACLAuthorizations'] != null) {
            headerParameters['X-BOL-ACL-authorizations'] = String(requestParameters['xBOLACLAuthorizations']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceRequestToJSON(requestParameters['serviceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceRequestResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a new ServiceRequest.  When creating a ServiceRequest, the value of the header `X-BOL-Member-Identifier` defines the ServiceRequest\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a ServiceRequest, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the ServiceRequest and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the ServiceRequest, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the ServiceRequest.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a ServiceRequest
     */
    async createServiceRequest(requestParameters: CreateServiceRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceRequestResponse | null | undefined > {
        const response = await this.createServiceRequestRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Create an Event of a ServiceRequest by `serviceRequestId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a ServiceRequest resource. 
     * Create an Event of a ServiceRequest
     */
    async createServiceRequestEventRaw(requestParameters: CreateServiceRequestEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling createServiceRequestEvent().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createServiceRequestEvent().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createServiceRequestEvent().'
            );
        }

        if (requestParameters['eventCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventCreateRequest',
                'Required parameter "eventCreateRequest" was null or undefined when calling createServiceRequestEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/events`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateRequestToJSON(requestParameters['eventCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Create an Event of a ServiceRequest by `serviceRequestId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a ServiceRequest resource. 
     * Create an Event of a ServiceRequest
     */
    async createServiceRequestEvent(requestParameters: CreateServiceRequestEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createServiceRequestEventRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a ServiceRequest resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the ServiceRequest resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a ServiceRequest resource. 
     * Delete an authorization of an access control list of a ServiceRequest by memberId
     */
    async deleteServiceRequestACLAuthorizationByMemberIdRaw(requestParameters: DeleteServiceRequestACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling deleteServiceRequestACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteServiceRequestACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteServiceRequestACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a ServiceRequest resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the ServiceRequest resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a ServiceRequest resource. 
     * Delete an authorization of an access control list of a ServiceRequest by memberId
     */
    async deleteServiceRequestACLAuthorizationByMemberId(requestParameters: DeleteServiceRequestACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteServiceRequestACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific ServiceRequest resource, identified by its `ServiceRequestId`.  - When a ServiceRequest is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a ServiceRequest resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a ServiceRequest resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a ServiceRequest resource. 
     * Delete a ServiceRequest by serviceRequestId
     */
    async deleteServiceRequestByIdRaw(requestParameters: DeleteServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling deleteServiceRequestById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific ServiceRequest resource, identified by its `ServiceRequestId`.  - When a ServiceRequest is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a ServiceRequest resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a ServiceRequest resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a ServiceRequest resource. 
     * Delete a ServiceRequest by serviceRequestId
     */
    async deleteServiceRequestById(requestParameters: DeleteServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteServiceRequestByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a ServiceRequest resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a ServiceRequest resource. 
     * Delete an event of a ServiceRequest by id
     */
    async deleteServiceRequestEventByIdRaw(requestParameters: DeleteServiceRequestEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling deleteServiceRequestEventById().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteServiceRequestEventById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteServiceRequestEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a ServiceRequest resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a ServiceRequest resource. 
     * Delete an event of a ServiceRequest by id
     */
    async deleteServiceRequestEventById(requestParameters: DeleteServiceRequestEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteServiceRequestEventByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given ServiceRequest, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the ServiceRequest resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a ServiceRequest by changeRequestId
     */
    async getChangeRequestOnServiceRequestByIdRaw(requestParameters: GetChangeRequestOnServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling getChangeRequestOnServiceRequestById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling getChangeRequestOnServiceRequestById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given ServiceRequest, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the ServiceRequest resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a ServiceRequest by changeRequestId
     */
    async getChangeRequestOnServiceRequestById(requestParameters: GetChangeRequestOnServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.getChangeRequestOnServiceRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a ServiceRequest resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a ServiceRequest resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a ServiceRequest by memberId
     */
    async getServiceRequestACLAuthorizationByMemberIdRaw(requestParameters: GetServiceRequestACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling getServiceRequestACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getServiceRequestACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a ServiceRequest resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a ServiceRequest resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a ServiceRequest by memberId
     */
    async getServiceRequestACLAuthorizationByMemberId(requestParameters: GetServiceRequestACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.getServiceRequestACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific ServiceRequest resource, identified by its `ServiceRequestId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the ServiceRequest and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a ServiceRequest resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a ServiceRequest for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getServiceRequestACLByIdRaw(requestParameters: GetServiceRequestACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACL>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling getServiceRequestACLById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/acl`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific ServiceRequest resource, identified by its `ServiceRequestId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the ServiceRequest and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a ServiceRequest resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a ServiceRequest for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getServiceRequestACLById(requestParameters: GetServiceRequestACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACL> {
        const response = await this.getServiceRequestACLByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific ServiceRequest by its `ServiceRequestId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this ServiceRequest resource. 
     * Get a ServiceRequest by serviceRequestId
     */
    async getServiceRequestByIdRaw(requestParameters: GetServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceRequestResponse>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling getServiceRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceRequestResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific ServiceRequest by its `ServiceRequestId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this ServiceRequest resource. 
     * Get a ServiceRequest by serviceRequestId
     */
    async getServiceRequestById(requestParameters: GetServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceRequestResponse> {
        const response = await this.getServiceRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List Events of a ServiceRequest by `serviceRequestId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a ServiceRequest resource. 
     * List Events of a ServiceRequest
     */
    async getServiceRequestEventsRaw(requestParameters: GetServiceRequestEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEvents>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling getServiceRequestEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['startAt'] != null) {
            queryParameters['startAt'] = requestParameters['startAt'];
        }

        if (requestParameters['endAt'] != null) {
            queryParameters['endAt'] = requestParameters['endAt'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/events`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEventsFromJSON(jsonValue));
    }

    /**
     * ## Description  List Events of a ServiceRequest by `serviceRequestId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a ServiceRequest resource. 
     * List Events of a ServiceRequest
     */
    async getServiceRequestEvents(requestParameters: GetServiceRequestEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEvents> {
        const response = await this.getServiceRequestEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific ServiceRequest by its `ServiceRequestId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a ServiceRequest metadata by serviceRequestId
     */
    async getServiceRequestMetadataByIdRaw(requestParameters: GetServiceRequestMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogisticsObjectMetadata>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling getServiceRequestMetadataById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/metadata`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogisticsObjectMetadataFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific ServiceRequest by its `ServiceRequestId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a ServiceRequest metadata by serviceRequestId
     */
    async getServiceRequestMetadataById(requestParameters: GetServiceRequestMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogisticsObjectMetadata> {
        const response = await this.getServiceRequestMetadataByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified ServiceRequest, identified by its `ServiceRequestId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given ServiceRequest resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a ServiceRequest resource. 
     * Get a list of ChangeRequest for ServiceRequest
     */
    async listChangeRequestsOfServiceRequestByIdRaw(requestParameters: ListChangeRequestsOfServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChangeRequests>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling listChangeRequestsOfServiceRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/change-requests`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChangeRequestsFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified ServiceRequest, identified by its `ServiceRequestId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given ServiceRequest resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a ServiceRequest resource. 
     * Get a list of ChangeRequest for ServiceRequest
     */
    async listChangeRequestsOfServiceRequestById(requestParameters: ListChangeRequestsOfServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChangeRequests> {
        const response = await this.listChangeRequestsOfServiceRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing ServiceRequest identified by its `ServiceRequestId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a ServiceRequest resource. 
     * Partially update a ServiceRequest by applying a JSON Merge Patch change request
     */
    async patchServiceRequestByIdRaw(requestParameters: PatchServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceRequestResponse>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling patchServiceRequestById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchServiceRequestById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling patchServiceRequestById().'
            );
        }

        if (requestParameters['serviceRequest'] == null) {
            throw new runtime.RequiredError(
                'serviceRequest',
                'Required parameter "serviceRequest" was null or undefined when calling patchServiceRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceRequestToJSON(requestParameters['serviceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceRequestResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing ServiceRequest identified by its `ServiceRequestId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a ServiceRequest resource. 
     * Partially update a ServiceRequest by applying a JSON Merge Patch change request
     */
    async patchServiceRequestById(requestParameters: PatchServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceRequestResponse> {
        const response = await this.patchServiceRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of ServiceRequest resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on ServiceRequests.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of ServiceRequest resources. 
     * Search for ServiceRequests
     */
    async searchServiceRequestGetRaw(requestParameters: SearchServiceRequestGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchServiceRequestsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['searchBody'] != null) {
            queryParameters['searchBody'] = requestParameters['searchBody'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchServiceRequestsResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of ServiceRequest resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on ServiceRequests.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of ServiceRequest resources. 
     * Search for ServiceRequests
     */
    async searchServiceRequestGet(requestParameters: SearchServiceRequestGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchServiceRequestsResponse> {
        const response = await this.searchServiceRequestGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of ServiceRequest resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on ServiceRequests.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of ServiceRequest resources. 
     * Search for ServiceRequests
     */
    async searchServiceRequestsPostRaw(requestParameters: SearchServiceRequestsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchServiceRequestsResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling searchServiceRequestsPost().'
            );
        }

        if (requestParameters['searchServiceRequestsRequest'] == null) {
            throw new runtime.RequiredError(
                'searchServiceRequestsRequest',
                'Required parameter "searchServiceRequestsRequest" was null or undefined when calling searchServiceRequestsPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchServiceRequestsRequestToJSON(requestParameters['searchServiceRequestsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchServiceRequestsResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of ServiceRequest resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on ServiceRequests.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of ServiceRequest resources. 
     * Search for ServiceRequests
     */
    async searchServiceRequestsPost(requestParameters: SearchServiceRequestsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchServiceRequestsResponse> {
        const response = await this.searchServiceRequestsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given ServiceRequest, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a ServiceRequest resource. 
     * Accept or reject a ChangeRequest on a  ServiceRequest using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnServiceRequestByIdRaw(requestParameters: UpdateChangeRequestOnServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling updateChangeRequestOnServiceRequestById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling updateChangeRequestOnServiceRequestById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateChangeRequestOnServiceRequestById().'
            );
        }

        if (requestParameters['changeRequestPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestPatchRequest',
                'Required parameter "changeRequestPatchRequest" was null or undefined when calling updateChangeRequestOnServiceRequestById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestPatchRequestToJSON(requestParameters['changeRequestPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given ServiceRequest, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a ServiceRequest resource. 
     * Accept or reject a ChangeRequest on a  ServiceRequest using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnServiceRequestById(requestParameters: UpdateChangeRequestOnServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.updateChangeRequestOnServiceRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing ServiceRequest identified by its `ServiceRequestId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a ServiceRequest resource. 
     * Update an existing ServiceRequest by creating and applying a change request
     */
    async updateServiceRequestByIdRaw(requestParameters: UpdateServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceRequestResponse>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling updateServiceRequestById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateServiceRequestById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling updateServiceRequestById().'
            );
        }

        if (requestParameters['serviceRequest'] == null) {
            throw new runtime.RequiredError(
                'serviceRequest',
                'Required parameter "serviceRequest" was null or undefined when calling updateServiceRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceRequestToJSON(requestParameters['serviceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceRequestResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing ServiceRequest identified by its `ServiceRequestId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a ServiceRequest resource. 
     * Update an existing ServiceRequest by creating and applying a change request
     */
    async updateServiceRequestById(requestParameters: UpdateServiceRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceRequestResponse> {
        const response = await this.updateServiceRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific ServiceRequest resource, identified by its `ServiceRequestId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a ServiceRequest resource. 
     * Upsert (create or update) an authorization of an access control list of a ServiceRequest.
     */
    async upsertServiceRequestACLAuthorizationByIdRaw(requestParameters: UpsertServiceRequestACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['serviceRequestId'] == null) {
            throw new runtime.RequiredError(
                'serviceRequestId',
                'Required parameter "serviceRequestId" was null or undefined when calling upsertServiceRequestACLAuthorizationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling upsertServiceRequestACLAuthorizationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling upsertServiceRequestACLAuthorizationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/service-requests/{serviceRequestId}/acl/authorizations`;
        urlPath = urlPath.replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(requestParameters['serviceRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ACLAuthorizationRequestToJSON(requestParameters['aCLAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific ServiceRequest resource, identified by its `ServiceRequestId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a ServiceRequest resource. 
     * Upsert (create or update) an authorization of an access control list of a ServiceRequest.
     */
    async upsertServiceRequestACLAuthorizationById(requestParameters: UpsertServiceRequestACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.upsertServiceRequestACLAuthorizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateChangeRequestOnServiceRequestByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnServiceRequestByIdContentTypeEnum = typeof CreateChangeRequestOnServiceRequestByIdContentTypeEnum[keyof typeof CreateChangeRequestOnServiceRequestByIdContentTypeEnum];
/**
 * @export
 */
export const CreateChangeRequestOnServiceRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnServiceRequestByIdAcceptEnum = typeof CreateChangeRequestOnServiceRequestByIdAcceptEnum[keyof typeof CreateChangeRequestOnServiceRequestByIdAcceptEnum];
/**
 * @export
 */
export const CreateServiceRequestContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateServiceRequestContentTypeEnum = typeof CreateServiceRequestContentTypeEnum[keyof typeof CreateServiceRequestContentTypeEnum];
/**
 * @export
 */
export const CreateServiceRequestAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateServiceRequestAcceptEnum = typeof CreateServiceRequestAcceptEnum[keyof typeof CreateServiceRequestAcceptEnum];
/**
 * @export
 */
export const CreateServiceRequestEventContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateServiceRequestEventContentTypeEnum = typeof CreateServiceRequestEventContentTypeEnum[keyof typeof CreateServiceRequestEventContentTypeEnum];
/**
 * @export
 */
export const CreateServiceRequestEventAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateServiceRequestEventAcceptEnum = typeof CreateServiceRequestEventAcceptEnum[keyof typeof CreateServiceRequestEventAcceptEnum];
/**
 * @export
 */
export const GetChangeRequestOnServiceRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetChangeRequestOnServiceRequestByIdAcceptEnum = typeof GetChangeRequestOnServiceRequestByIdAcceptEnum[keyof typeof GetChangeRequestOnServiceRequestByIdAcceptEnum];
/**
 * @export
 */
export const GetServiceRequestACLAuthorizationByMemberIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetServiceRequestACLAuthorizationByMemberIdAcceptEnum = typeof GetServiceRequestACLAuthorizationByMemberIdAcceptEnum[keyof typeof GetServiceRequestACLAuthorizationByMemberIdAcceptEnum];
/**
 * @export
 */
export const GetServiceRequestACLByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetServiceRequestACLByIdAcceptEnum = typeof GetServiceRequestACLByIdAcceptEnum[keyof typeof GetServiceRequestACLByIdAcceptEnum];
/**
 * @export
 */
export const GetServiceRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetServiceRequestByIdAcceptEnum = typeof GetServiceRequestByIdAcceptEnum[keyof typeof GetServiceRequestByIdAcceptEnum];
/**
 * @export
 */
export const GetServiceRequestEventsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetServiceRequestEventsAcceptEnum = typeof GetServiceRequestEventsAcceptEnum[keyof typeof GetServiceRequestEventsAcceptEnum];
/**
 * @export
 */
export const GetServiceRequestMetadataByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetServiceRequestMetadataByIdAcceptEnum = typeof GetServiceRequestMetadataByIdAcceptEnum[keyof typeof GetServiceRequestMetadataByIdAcceptEnum];
/**
 * @export
 */
export const ListChangeRequestsOfServiceRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListChangeRequestsOfServiceRequestByIdAcceptEnum = typeof ListChangeRequestsOfServiceRequestByIdAcceptEnum[keyof typeof ListChangeRequestsOfServiceRequestByIdAcceptEnum];
/**
 * @export
 */
export const PatchServiceRequestByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchServiceRequestByIdContentTypeEnum = typeof PatchServiceRequestByIdContentTypeEnum[keyof typeof PatchServiceRequestByIdContentTypeEnum];
/**
 * @export
 */
export const PatchServiceRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchServiceRequestByIdAcceptEnum = typeof PatchServiceRequestByIdAcceptEnum[keyof typeof PatchServiceRequestByIdAcceptEnum];
/**
 * @export
 */
export const SearchServiceRequestGetAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchServiceRequestGetAcceptEnum = typeof SearchServiceRequestGetAcceptEnum[keyof typeof SearchServiceRequestGetAcceptEnum];
/**
 * @export
 */
export const SearchServiceRequestsPostContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchServiceRequestsPostContentTypeEnum = typeof SearchServiceRequestsPostContentTypeEnum[keyof typeof SearchServiceRequestsPostContentTypeEnum];
/**
 * @export
 */
export const SearchServiceRequestsPostAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchServiceRequestsPostAcceptEnum = typeof SearchServiceRequestsPostAcceptEnum[keyof typeof SearchServiceRequestsPostAcceptEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnServiceRequestByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnServiceRequestByIdContentTypeEnum = typeof UpdateChangeRequestOnServiceRequestByIdContentTypeEnum[keyof typeof UpdateChangeRequestOnServiceRequestByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnServiceRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnServiceRequestByIdAcceptEnum = typeof UpdateChangeRequestOnServiceRequestByIdAcceptEnum[keyof typeof UpdateChangeRequestOnServiceRequestByIdAcceptEnum];
/**
 * @export
 */
export const UpdateServiceRequestByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateServiceRequestByIdContentTypeEnum = typeof UpdateServiceRequestByIdContentTypeEnum[keyof typeof UpdateServiceRequestByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateServiceRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateServiceRequestByIdAcceptEnum = typeof UpdateServiceRequestByIdAcceptEnum[keyof typeof UpdateServiceRequestByIdAcceptEnum];
/**
 * @export
 */
export const UpsertServiceRequestACLAuthorizationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertServiceRequestACLAuthorizationByIdContentTypeEnum = typeof UpsertServiceRequestACLAuthorizationByIdContentTypeEnum[keyof typeof UpsertServiceRequestACLAuthorizationByIdContentTypeEnum];
/**
 * @export
 */
export const UpsertServiceRequestACLAuthorizationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertServiceRequestACLAuthorizationByIdAcceptEnum = typeof UpsertServiceRequestACLAuthorizationByIdAcceptEnum[keyof typeof UpsertServiceRequestACLAuthorizationByIdAcceptEnum];
